import { IncidentsList } from "./IncidentsList";

export default IncidentsList;
